import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpErrorResponse } from "@angular/common/http";

import { throwError } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { environment } from "src/environments/environment";

export interface MenuInfo {
	id: number;
	name: string;
	icons?: string;
	routerLink: string;
}

export interface MenuData {
	id: number;
	name: string;
	icons?: string;
	routerLink: string;
	subMenus?: MenuInfo[];
}

@Injectable()
export class ConfigService {
	configUrl = environment.clientUrl + "/assets/json/admin.json";

	constructor(private http: HttpClient) {}

	getConfig() {
		return this.http.get<MenuData[]>(this.configUrl).pipe(
			retry(3), // retry a failed request up to 3 times
			catchError(this.handleError) // then handle the error
		);
	}

	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
			// A client-side or network error occurred. Handle it accordingly.
			console.error("An error occurred:", error.error.message);
		} else {
			// The backend returned an unsuccessful response code.
			// The response body may contain clues as to what went wrong,
			console.error(
				`Backend returned code ${error.status}, ` +
					`body was: ${error.error}`
			);
		}
		// return an observable with a user-facing error message
		return throwError("Something bad happened; please try again later.");
	}
}
